<template>
  <div>
    <AuthModal @login-success="$emit('login-success')" />

    <ErrorModal />

    <WidgetsModal />

    <CampaignSentModal />

    <ReviewModal :store-name="storeName" />

    <SendCampaignModal />

    <DownloadCampaignModal />

    <!-- Part of vue-modal - used for alerts and simple dialogs -->
    <v-dialog />
  </div>
</template>

<script>
import AuthModal from "@/components/Auth/AuthModal";
import ErrorModal from "@/components/UI/ErrorModal";
import WidgetsModal from "@/components/Editor/Layout/Widgets/WidgetsModal";
import ReviewModal from "@/components/Feedback/ReviewModal";
import CampaignSentModal from "@/components/Campaigns/CampaignSentModal";
import SendCampaignModal from "@/components/Campaigns/SendCampaign/SendCampaignModal";
import DownloadCampaignModal from "@/components/Campaigns/DownloadCampaign/DownloadCampaignModal";

export default {
  name: "Modals",
  components: {
    AuthModal,
    CampaignSentModal,
    DownloadCampaignModal,
    ErrorModal,
    ReviewModal,
    SendCampaignModal,
    WidgetsModal,
  },
  props: {
    storeName: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped></style>
